// import { TCommandTimeDetails } from 'src/app/components/CommandModal/command-modal.config';
import { EAlgiDurumu, EEmirTuru, EEngamentRule, EIstemci2DOlayTipi, ERaporKodu } from 'src/enums/mixed.enum';
import { MMUReceivedMessageType } from './mmu.type';
import { EAgentController, EnvironmentalUnit, EtmenTuruGuncellemeType } from '../unit.type';
import { TaraflarArasiIliskiResultType } from '../services/hymotsc/taraflar-arasi-iliskiler.type';

export type BaseMesajType = {
  zipliMi: boolean;
};

export type ReceivedMessageType =
  | EmirCevapType
  | EtmenGuncellemeMesajType
  | SurferInfoType
  | MMUReceivedMessageType
  | TarafIliskiGuncellemeMesajType
  | HLAGuncellemeType
  | ExperimentationReportMessageType;

export type ExperimentationReportMessageType = {
  oyunId: number;
  aliciId: number;
  gonderenId: number;
  icerik: ExperimentationReportIcerikType;
  mesajTipi: EMesajTipi.RAPOR;
  mesajAltTipi: EMesajAltTipi;
} & BaseMesajType;

export type ExperimentationReportIcerikType = {
  butunSayfaSiniri: number;
  data?: ResponseData[];
  errorMessage: string;
  response: 'positive' | 'negative';
};

interface ResponseData {
  cumulativeData: number[];
  peridoicData: number[];
  tarafId: number;
}

export type TarafIliskiGuncellemeMesajType = {
  icerik: {
    tarafIliskileri: TaraflarArasiIliskiResultType[];
  };
  mesajTipi: EMesajTipi.TARAF_ILISKISI;
  mesajAltTipi: EMesajAltTipi.TARAF_ILISKISI_GUNCELLEMESI;
} & BaseMesajType;

export type EtmenGuncellemeType = {
  algiDurumu: EAlgiDurumu;
  emirId: number;
  faaliyet: number;
  formasyonId: number;
  hedefEtmenVtId: number;
  istikametAcisi: number;
  harekatSafhasi: number;
  magicIkmal: boolean;
  insanZayiatOrani?: number;
  otonomZayiatOrani?: number;
  eklentiId: number;
  aisStatus: boolean;

  emirler: number[];

  konum: string;

  ikmalDurumlari: string;

  unsurTMK: string;
  unsurDenizAraci: string;
  unsurHavaAraci: string;
  unsurUzayAraci: string;
  unsurInsanYapimiEngel: string;
  unsurMuhabereCihazi: string;
  etmenKontrolcusu: EAgentController;

  rota?: string;
  rotaSirasi?: number;
  rotaBolgeMi?: boolean;
  kontrolBolgesi?: string;

  angajmanKurali: EEngamentRule;
  ustIsletenEtmenVtId?: number | bigint;
  ikmalindenSorumluEtmenVtId?: number | bigint;
  hacim: string;
  hiz: number;
  etkinlik: string;
  bindirilmisMi: boolean;
  manifesto: string;
  savunma: string;

  vtId: number;
  emirKuyrugu: string;
  beklemeSuresi: number;
  havadaBekliyorMu: boolean;
  muhabereKaraListe: string;
  muhabereKuruluOlanEtmenler: string;
  etmenTipi: EEtmenTipi.KARA;
  etmenAktiflikDurumu: number;
  sonBilinenAlgiDurumu: EAlgiDurumu;

  sidc?: string;
  runTimeSirasindaOlusturuldu: boolean;
  kisaIsim: string;
  uzunIsim: string;
  etmenTuruVtId: number;
};

export type OlayType = {
  ozneId: number | bigint;
  tip: EIstemci2DOlayTipi;
  zaman: number;
};
// export type ReceivedMessageType = EmirCevapType | EtmenGuncellemeMesajType | SurferInfoType;

export type ZamanGuncellemeType = {
  tc: number;
  th: number;
  tz: number;
  istemciGuncellemePeriyoduAdimSayisi: number;
  senkron: boolean;
  tcMax: number;
  te: number;
  thMin: number;
  tm: number;
  to: number;
  ts: number;
};

export type EmirCevapType = {
  icerik: GameLog | '';
  mesajAltTipi: 2;
  mesajTipi: 2;
} & BaseMesajType;

export type MMUCevapType = {
  icerik: string;
  mesajAltTipi: 4;
  mesajTipi: 3;
};

export type EtmenGuncellemeMesajType = {
  icerik: {
    etmenler: EtmenGuncellemeType[];
    etmenTuru: EtmenTuruGuncellemeType[];
    zaman: string;
    runId?: string;
    oyunId?: number;
    olaylar: string;
  };
  mesajAltTipi: EMesajAltTipi;
  mesajTipi: EMesajTipi.GENEL;
  oyunId?: number;
} & BaseMesajType;

export type SurferInfoType = {
  // TODO Change to Code
  icerik: string;
  mesajAltTipi: 4;
  mesajTipi: 3;
} & BaseMesajType;

// export type EmirCevapType = {
//   icerik: GameLog | '';
//   mesajAltTipi: 2;
//   mesajTipi: 2;
// };

// export type TKuyrukGuncelleme = {
//   etmenId: number;
//   emirKuyrugu: number[];
//   zamanDetaylari: TCommandTimeDetails;
// };

export enum EEmirAliciTipi {
  BOS = 0,
  ETMEN = 1,
  DISASTER = 4,
  KONTROL = 5,
} // End enum EmirAliciTipi

export enum EMesajTipi {
  GENEL = 1,
  EMIR = 2,
  EKLENTI = 3,
  TARAF_ILISKISI = 4,
  ETMEN_INDEX_ID = 5,
  SABITLER = 6,
  VERSIYON = 7,
  ALGI = 8,
  SIM_TANITIM_3D = 9,
  RAPOR = 10,
  RUN_ISLEMLERI = 11,
  MMU = 12,
  DENEY = 13,
  ETMEN_TURU = 14,
  NIZAM = 15,
  COMAO = 16,
  HLA = 17,
  CGA = 18,
  YIKILAN_BINALAR = 19,

  HATA = 255,
} // End enum MesajTipi

export enum EMesajAltTipi {
  BAGLANTI_TALEBI = 1,
  BAGLANTI_KABUL = 2,
  BAGLANTI_RET = 3,
  ARKAYUZ_HAZIR_DEGIL = 4,
  SIMULASYON_DURUM_GUNCELLEMESI_2D = 5,
  SIMULASYON_DURUM_GUNCELLEMESI_3D = 6,
  ISTEMCI_KOPTU = 7,
  OYUN_YUKLE = 8,
  GUNCELLEME_GONDER_BASLAT = 9,
  GUNCELLEME_GONDER_DURDUR = 10,
  OYUN_YUKLEME_BASARILI = 11,
  ISTEMCI_TANINMIYOR = 12,
  TARAF_ILISKISI_GUNCELLEMESI = 13,
  ETMEN_INDEX_VE_ID_GUNCELLEMESI = 14,
  SABITLER_GUNCELLEMESI = 15,
  SIMULASYON_DURUM_KAYDI = 16,
  VERSIYON_GUNCELLEMESI = 17,
  ALGI_GUNCELLEMESI = 18,
  SIMULASYON_TANITIM_3D = 19,
  ARKAYUZ_HAZIR = 20,
  ISTEMCI_ETMENI_ATANMAMIS = 21,
  ISTEMCI_TARAFI_BILINMIYOR = 22,
  RAPOR_ISTEGI = 23,
  RAPOR_CEVABI = 24,
  YENI_EMIR = 25,
  EMIR_CEVABI = 26,
  RUN_CHECKPOINT_SILME_ISTEGI = 27,
  RUN_CHECKPOINT_SILME_BASARILI = 28,
  RUN_CHECKPOINT_SILME_BASARISIZ = 29,
  UYGULAMA_EKLE = 30,
  UYGULAMA_KALDIR = 31,
  UYGULAMA_DURDUR = 32,
  UYGULAMA_DEVAM_ETTIR = 33,
  UYGULAMA_YENIDEN_BASLAT = 34,
  UYGULAMA_BASARILI = 35,
  ABONELIK_EKLE = 36,
  ABONELIK_CIKAR = 37,
  KAYITLI_EMIRLERI_UYGULA = 38,
  ISTEMCI_3D_BROADCAST = 39,
  DENEY_HATALI_EMIRLER = 40,
  DENEY_LOG_ARALIGI = 41,
  SON_LOG_ZAMANI = 42,
  UYGULAMA_COKTU = 43,
  SUNUCU_BAGLI_ISTEMCI_BILGISI_GUNCELLEME = 44,
  YONLENDIRME = 45,
  ISTEMCI_3D_KONUM_GUNCELLEME = 46,
  SIMULASYON_ETMEN_GUNCELLEMESI_3D = 47,
  UYGUN_SURFER_BULUNMUYOR = 48,
  CALISAN_HYMOTSC_BULUNMUYOR = 49,
  DENEY_OYUNU_EKLE = 50,
  GUVEN_ARALIGI_ISTEGI = 51,
  GUVEN_ARALIGI_CEVABI = 52,
  DENEY_DURUM_GUNCELLEME = 53,
  DENEY_DURDUR = 54,
  KOSU_AGACINI_PAYLAS = 55,
  DENEY_YUKLENEBILECEK_CHECKPOINT_BULUNMUYOR = 56,
  SIMULASYON_TANITIM_GUNCELLEMESI_2D = 57,
  SIMULASYON_TANITIM_GUNCELLEMESI_3D = 58,
  SUNUCU_KAPANMA_SEKANSI = 59,
  OWNSITREP = 60, // Kullanıcı rapor isteğinde tür belirlemek için kullanılır.
  ENSITREP = 61, // Kullanıcı rapor isteğinde tür belirlemek için kullanılır.
  INTSUM = 62, // Kullanıcı rapor isteğinde tür belirlemek için kullanılır.
  ATO = 63, // Kullanıcı rapor isteğinde tür belirlemek için kullanılır.
  HYMOTS_E_UYGUNLUK_GUNCELLEMESI = 64,
  SITREP = 65,
  AAR_KAYDI = 66,
  AAR_LISTESI_ISTEGI = 67,
  ETMEN_TURU_TANITIM_GUNCELLEMESI = 68, // İlk etmen türü mesjaı
  ETMEN_TURU_DURUM_GUNCELLEMESI = 69, // Değişen etmen türlerinin mesajı
  NIZAM_TANITIM_GUNCELLEMESI = 70,
  NIZAM_DURUMU_GUNCELLEMESI = 71,
  COMAO_TANITIM_GUNCELLEMESI = 72,
  COMAO_DURUMU_GUNCELLEMESI = 73,
  DIZINLERI_OLUSTURMA_ISTEGI = 74,
  LRC_RTI_BAGLAN = 75, // HLA Modülünde kullanılır
  LRC_RTI_BAGLANTI_KES = 76, // HLA Modülünde kullanılır
  LRC_RTI_BAGLANTISI_BASARILI = 77, // HLA Modülünde kullanılır
  LRC_RTI_BAGLANTISI_BASARISIZ = 78, // HLA Modülünde kullanılır
  LRC_RTI_BAGLANTISI_KESILDI = 79, // HLA Modülünde kullanılır
  LRC_RTI_BAGLANTISI_KULLANICI_TARAFINDAN_KESILDI = 80, // HLA Modülünde kullanılır
  FEDERASYON_OLUSTURULDU = 81, // HLA Modülünde kullanılır
  FEDERASYON_OLUSTURMA_BASARISIZ = 82, // HLA Modülünde kullanılır
  FEDERASYONA_KATILMA_BASARILI = 83, // HLA Modülünde kullanılır
  FEDERASYONA_KATILMA_BASARISIZ = 84, // HLA Modülünde kullanılır
  AAR_SAYISI_ISTEGI = 85,
  AAR_ISTEK = 86,
  AAR_ETIKET_DEGISTIR = 87,
  EMIR_CEVABI_KAYDI = 88,
  EMIR_CEVABI_SAYISI = 89,
  EMIR_CEVABI_LISTESI_ISTEGI = 90,
  AAR_SAYISI_CEVABI = 91,
  AAR_CEVABI = 92,
  AAR_ETIKET_CEVABI = 93,
  EMIR_CEVABI_LISTESI = 94,
  AAR_LISTESI_CEVABI = 95,
  TOPOLOJI_CEVABI = 97,
  LRC_RTI_BAGLANTISI_TAMAMLANDI = 98, // HLA Modülünde kullanılır
  UYGULAMA_PERFORMANS_BILDIRGESI = 99,
  UYGULAMA_PERFORMANS_YAYIMI = 100,
  EMIR_MISREP_KAYDI = 101,
  LRC_OBSERVATION_REPORT_GONDER = 102, // HLA Modülünde kullanılır
  LRC_ENTITY_TO_REFLECT = 103,
  GAME_HISTORY_ISTEK = 104,
  GAME_HISTORY_CEVAP = 105,
  CGA_BAGLANTISI_MEVCUT_DEGIL = 106,
  CGA_ETMEN_GUNCELLEMESI = 107,
  CGA_GONDERILECEK_BILGILERI_ILET = 108,
  CGA_ISTEMCI_ARAZI_GUNCELLEMESI = 109,
  OYUN_EMIR_ISTATISTIK_ISTEK = 115,
  OYUN_EMIR_ISTATISTIK_CEVAP = 116,
  CGA_TMKLAR_GUNCELLEMESI = 117,
  CGA_HAVA2D_GUNCELLEMESI = 118,
  SIMULASYON_TANITIM_3D_ILET = 119,
  YIKILAN_BINA_TANITIM_GUNCELLEMESI = 120,
  YIKILAN_BINA_DURUM_GUNCELLEMESI = 121,
  HLA_ETMEN_TEMIZLE = 124,
  OLAY_RAPOR_KAYIT = 125,
  EMIR_UNIQUE_ID_ICIN_OLAY_ISTEK = 126,
  OLAY_RAPOR_LISTE_ISTEK = 127,
  ETMEN_ICIN_OLAY_RAPOR_ISTEK = 128,
  AIS_OLAYLAR = 131,
  LRC_ENTITIES_TO_REFLECT = 132,

  ATO_UPLOAD = 134,

  HATA = 255,
} // End GenelMesajlarMesajId

export type GameLog = {
  aciklama: string;
  raporKodu?: ERaporKodu;
  emirId: number;
  emirTuru: EEmirTuru;
  etmenId: number;
  etmenKonumu: {
    latitude: number;
    longitude: number;
    yukseklik: number;
  };
  zaman: number;
  runId?: string;
};

export type CombinedEtmenAndCevreselEtmenGuncellemeType = EtmenGuncellemeType | EnvironmentalUnit;

export enum EEtmenTipi {
  BOS = 0,
  KARA = 1,
  HAVA = 2,
  DENIZ = 3,
  ENGEL = 4,
  FUZE = 5,
  KBRN = 6,
  TORPIDO = 7,
  SU_ALTI_BOMBA = 8,
  DENIZ_KIRLILIGI = 9,
  DENIZ_MAYIN_BOLGESI = 10,
  DENIZ_MAYINI = 11,
  RESERVED = 12,
  UZAY = 13,
  SONOBUOY = 14,
  TREN = 15,
}
export enum EUcNokta {
  BOS = 0,
  ARKAYUZ = 1,
  ISTEMCI_2D = 2,
  ISTEMCI_3D = 3,
  ISTEMCI_EKLENTI = 4,
  ISTEMCI_ETECUBE = 5,
  SUNUCU_MMU = 6,
  ISTEMCI_MMU = 7,
  SUNUCU_HYMOTSE = 8,
  ISTEMCI_HYMOTSE = 9,
  SUNUCU_SURFER = 10,
  ISTEMCI_SURFER = 11,
} // End enum UcNokta

export enum EtmenDurumu {
  BOS = 0, // Boş alan, bölünen etmen bu alanı kullanabilir
  AKTIF = 1, // Şuan aktif olarak kullanılıyor
  PASIF = 2, // Etmen aktif olma zamanı gelmemiş.
  REZERVE = 3,
}

export enum EKontrolTipi {
  BOS = 0,
  YENI_EMIR = 1,
  EMIR_GUNCELLEME = 2,
  EMIR_IPTAL = 3,
  TOPLU_EMIR = 4,
} // End enum KontrolTipi

export type AARStatusType = {
  aarDurumu: string;
  aarEtiketi: string;
  aarId: string;
  isCheckpoint: boolean;
  oyunZamani: number;
  runId: string;
};

export type AARStatusConvertedType = Omit<AARStatusType, 'aarDurumu'> & {
  aarDurumu: any;
};

export type HLAGuncellemeType = {
  icerik: any;
  mesajTipi: EMesajTipi.HLA;
  mesajAltTipi: EMesajAltTipi;
  aliciId: number;
  aliciSunucuId: number;
  oyunId: number;
} & BaseMesajType;
